/* ZehenFit funnel fixes — 2026-08-23, revised 2026-08-25
   1. Repoint the funnel add-to-cart forms to the live variant. Three forms in
      Custom Liquid Part 3 still carry a deleted variant id (57632709837131),
      which makes /cart/add return 422. The live id is read from the working
      top buy box, so nothing is hardcoded and it cannot go stale.
   2. Keep every quantity input in sync with the bundle selector, including the
      .zfp-qty-sync inputs the original script never reached.
   3. Replace the cart instead of adding to it, so a second tap or a back-button
      round trip can no longer stack 4, 6 or 8 pairs into the checkout.
   4. Carry fbclid / utm_* from the advertorial through to the product page, and
      persist fbclid into a first-party _fbc cookie once marketing consent exists.

   Scope: only forms belonging to the zfp funnel are intercepted. Theme quick-add
   and any other /cart/add form on the store is left completely untouched.

   --- 2026-08-25 revision, FRANCE ONLY -------------------------------------
   IS_FR is true only on the France market storefront (oldpatek.fr). Every
   change below is gated on it, so DACH and US behaviour is byte-for-byte
   identical to the 2026-08-23 version.

   a) Sticky price label. The hardcoded PRICES map only ever matched the FR
      ladder (39,99 / 49,99 / 59,99). On FR the label is now read from the
      selected offer card instead, so it can never contradict the buy box and
      survives a repricing with no code edit. Off FR the old map still applies.
   b) Quantity sync. On FR the sticky and secondary forms are matched by
      position rather than by the .zfp-qty-sync class, so the Set Actif sticky
      bar — whose quantity input carries no class — now follows the selector
      instead of being stuck at 1. No template edit required.
   c) Cart write. On FR, /cart/update.js sets an absolute quantity for the
      submitted variant and leaves every other line item alone. Duplicate
      stacking is still impossible, because update sets rather than adds.
      Off FR, the original /cart/clear.js + /cart/add.js chain is unchanged.
*/
(function () {
  'use strict';

  if (window.__zfpFixes) return;
  window.__zfpFixes = true;

  var IS_FR = /(^|\.)oldpatek\.fr$/i.test(window.location.hostname);

  var FUNNEL_FORM = '.zfp-buy-form, .zfp-cta-form';
  var STICKY = '#zfpSticky';
  var PRICES = { '1': '39,99 €', '2': '49,99 €', '3': '59,99 €' };
  var QTY_SYNC_FR = '.zfp-qty-sync, #zfpSticky form [name="quantity"], .zfp-cta-form [name="quantity"]';
  var KEEP = ['fbclid', 'gclid', 'ttclid', 'msclkid', 'utm_source', 'utm_medium',
              'utm_campaign', 'utm_content', 'utm_term', 'utm_id'];

  function isFunnelForm(form) {
    if (!form) return false;
    if (form.matches && form.matches(FUNNEL_FORM)) return true;
    return !!(form.closest && form.closest(STICKY));
  }

  /* ---------------------------------------------------------------
     4a. Carry click ids and utm across internal links
  --------------------------------------------------------------- */
  var carry = {};
  var hasCarry = false;

  try {
    var incoming = new URLSearchParams(window.location.search);
    for (var i = 0; i < KEEP.length; i++) {
      var value = incoming.get(KEEP[i]);
      if (value) {
        carry[KEEP[i]] = value;
        hasCarry = true;
      }
    }
  } catch (err) { /* older browser, skip decoration */ }

  function decorate(link) {
    if (!hasCarry) return;
    var href = link.getAttribute('href') || '';
    if (!href || /^(mailto:|tel:|sms:|javascript:|#)/i.test(href)) return;

    var url;
    try { url = new URL(href, window.location.href); } catch (err) { return; }
    if (url.hostname !== window.location.hostname) return;

    var changed = false;
    for (var key in carry) {
      if (!Object.prototype.hasOwnProperty.call(carry, key)) continue;
      if (!url.searchParams.has(key)) {
        url.searchParams.set(key, carry[key]);
        changed = true;
      }
    }
    if (changed) link.setAttribute('href', url.pathname + url.search + url.hash);
  }

  function decorateAll() {
    if (!hasCarry) return;
    var links = document.querySelectorAll('a[href]');
    for (var i = 0; i < links.length; i++) decorate(links[i]);
  }

  // Catch links injected after load, and anything the sweep missed.
  document.addEventListener('click', function (event) {
    var link = event.target && event.target.closest ? event.target.closest('a[href]') : null;
    if (link) decorate(link);
  }, true);

  /* ---------------------------------------------------------------
     4b. Persist fbclid into _fbc, only once marketing consent exists
  --------------------------------------------------------------- */
  function marketingAllowed() {
    try { return window.Shopify.customerPrivacy.marketingAllowed() === true; }
    catch (err) { return false; }
  }

  function writeFbc() {
    if (!carry.fbclid) return;
    if (document.cookie.indexOf('_fbc=') !== -1) return;
    var host = window.location.hostname.replace(/^www\./, '');
    document.cookie = '_fbc=fb.1.' + Date.now() + '.' + carry.fbclid +
      '; domain=.' + host + '; path=/; max-age=7776000; SameSite=Lax; Secure';
  }

  if (carry.fbclid) {
    if (marketingAllowed()) {
      writeFbc();
    } else {
      document.addEventListener('visitorConsentCollected', function () {
        if (marketingAllowed()) writeFbc();
      });
    }
  }

  /* ---------------------------------------------------------------
     1. Point every funnel form at the variant the buy box is using
  --------------------------------------------------------------- */
  function canonicalVariantId() {
    var input = document.querySelector('.zfp-buy-form [name="id"]');
    var value = input && input.value ? String(input.value).trim() : '';
    return /^[0-9]+$/.test(value) ? value : '';
  }

  function repointForms() {
    var canonical = canonicalVariantId();
    if (!canonical) return;
    var inputs = document.querySelectorAll(
      '.zfp-buy-form [name="id"], .zfp-cta-form [name="id"], #zfpSticky form [name="id"]'
    );
    for (var i = 0; i < inputs.length; i++) {
      if (inputs[i].value !== canonical) inputs[i].value = canonical;
    }
  }

  /* ---------------------------------------------------------------
     2. Quantity sync across every funnel form + sticky price label
  --------------------------------------------------------------- */
  function selectedPriceText() {
    var checked = document.querySelector('.zfp-v-input:checked');
    if (!checked || !checked.closest) return '';
    var card = checked.closest('.zfp-variant');
    var el = card ? card.querySelector('.zfp-v-price') : null;
    return el ? el.textContent.trim() : '';
  }

  function syncQuantity() {
    var checked = document.querySelector('.zfp-v-input:checked');
    if (!checked) return;
    var qty = checked.value;

    var main = document.getElementById('zfpQty');
    if (main) main.value = qty;

    var extras = document.querySelectorAll(IS_FR ? QTY_SYNC_FR : '.zfp-qty-sync');
    for (var i = 0; i < extras.length; i++) {
      if (extras[i].id !== 'zfpQty') extras[i].value = qty;
    }

    var stickyPrice = document.getElementById('zfpStickyPrice');
    if (!stickyPrice) return;
    if (IS_FR) {
      var priceText = selectedPriceText();
      if (priceText) stickyPrice.textContent = priceText;
    } else if (PRICES[qty]) {
      stickyPrice.textContent = PRICES[qty];
    }
  }

  document.addEventListener('change', function (event) {
    var target = event.target;
    if (target && target.classList && target.classList.contains('zfp-v-input')) {
      syncQuantity();
    }
  });

  /* ---------------------------------------------------------------
     3. Write the cart so quantity can never accumulate
        FR  : /cart/update.js  — absolute quantity, other lines kept
        else: /cart/clear.js + /cart/add.js — unchanged 2026-08-23 behaviour
  --------------------------------------------------------------- */
  document.addEventListener('submit', function (event) {
    var form = event.target && event.target.closest
      ? event.target.closest('form[action*="/cart/add"]')
      : null;
    if (!isFunnelForm(form)) return;

    repointForms();
    syncQuantity();

    var idInput = form.querySelector('[name="id"]');
    var qtyInput = form.querySelector('[name="quantity"]');
    var variantId = idInput ? Number(String(idInput.value).trim()) : 0;
    var quantity = parseInt(qtyInput && qtyInput.value, 10) || 1;

    // Nothing usable to send: let Shopify handle the plain POST.
    if (!variantId) return;

    event.preventDefault();

    var button = form.querySelector('button[type="submit"]');
    if (button) button.disabled = true;

    var settled = false;
    function fallBackToPlainPost() {
      if (settled) return;
      settled = true;
      if (button) button.disabled = false;
      form.submit();
    }
    var timer = setTimeout(fallBackToPlainPost, 6000);

    var request;
    if (IS_FR) {
      var updates = {};
      updates[String(variantId)] = quantity;
      request = fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ updates: updates })
      });
    } else {
      request = fetch('/cart/clear.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin'
      }).then(function () {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ items: [{ id: variantId, quantity: quantity }] })
        });
      });
    }

    request
      .then(function (response) {
        if (!response.ok) throw new Error('cart write returned ' + response.status);
        if (settled) return;
        settled = true;
        clearTimeout(timer);
        window.location.href = '/checkout';
      })
      .catch(function () {
        clearTimeout(timer);
        fallBackToPlainPost();
      });
  });

  /* --------------------------------------------------------------- */
  function init() {
    decorateAll();
    repointForms();
    syncQuantity();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Sticky bar and late sections can render after DOMContentLoaded.
  window.addEventListener('load', function () {
    repointForms();
    syncQuantity();
  });
})();
